import React from "react";
import { useHistory } from "react-router-dom";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";
import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { OnboardingPageContainer } from "../../components";
import { PageType } from "../../constants";
import { getImage, ImageType } from "../../helpers/imageHelper";
import { useString, useStrings } from "../../localization/localizationHelpers";
import * as styles from "./AccessDeniedPage.module.css";

type AccessDeniedPageProps = {
  footNote: string;
  pageType: PageType;
};

const AccessDeniedPage = ({ footNote, pageType }: AccessDeniedPageProps) => {
  const [oops, accessDenied, back] = useStrings("oops", "accessDenied", "back");
  const history = useHistory();

  return (
    <OnboardingPageContainer className={styles.accessDeniedContainer} pageType={pageType}>
      <Row>
        <Column className={styles.columnWrapper}>
          <Row className={styles.contentBox}>
            <Column>
              <img
                src={getImage("errorpage", ImageType.Png)}
                alt={"error"}
                className={styles.image}
              />
            </Column>
            <Column className={styles.contentColumn}>
              <div>
                <h1>{oops}</h1>
                <h2>{accessDenied}</h2>
                <p className={styles.pageFootNote}>{footNote}</p>
                <BasicButton
                  as={"a"}
                  buttonType={ButtonType.Brand}
                  className={styles.supportButton}
                  onClick={() => history.goBack()}
                >
                  {back}
                </BasicButton>
              </div>
            </Column>
          </Row>
        </Column>
      </Row>
    </OnboardingPageContainer>
  );
};

export const IdXboxExistingPartnerAccessDeniedPage = () => {
  const idXboxAccessDeniedFootnote = useString("idXboxAccessDeniedPageFootNote");
  return (
    <AccessDeniedPage footNote={idXboxAccessDeniedFootnote} pageType={PageType.IdXboxApplication} />
  );
};

export const IdXboxAccessDeniedPage = () => {
  const idXboxAccessDeniedFootnote = useString("accessDeniedPageFootNote");
  return (
    <AccessDeniedPage footNote={idXboxAccessDeniedFootnote} pageType={PageType.IdXboxApplication} />
  );
};

export const IdAzureAccessDeniedPage = () => {
  const idAzureAccessDeniedFootnote = useString("idAzureAccessDeniedPageFootNote");
  return (
    <AccessDeniedPage
      footNote={idAzureAccessDeniedFootnote}
      pageType={PageType.IdAzureApplication}
    />
  );
};

export const PitchAccessDeniedPage = () => {
  const pitchAccessDeniedFootnote = useString("accessDeniedPageFootNote");
  return (
    <AccessDeniedPage footNote={pitchAccessDeniedFootnote} pageType={PageType.PitchApplication} />
  );
};

export const AaaAccessDeniedPage = () => {
  const aaaAccessDeniedPageFootNote = useString("aaaAccessDeniedPageFootNote");
  return (
    <AccessDeniedPage footNote={aaaAccessDeniedPageFootNote} pageType={PageType.AaaApplication} />
  );
};
